<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="row mt-3 mb-3">
  <div class="col-12">
    <span class="font-weight-bold">{{titulo}}</span>
  </div>
</div>
<hr />
<div class="row mb-3">
  <div class="col-2">
    <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar prestação
    </button>
  </div>
  <div class="col-6">
    <button (click)="importar()" class="btn btn-sm btn-outline-secondary">
      <img src="assets/img/global/lightning.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Executar prestação de contas
    </button>
  </div>
</div>
<table class="table table-eddy" *ngIf="entidade">
  <thead>
    <tr>
      <th scope="col" style="width: 15%">Data Prest.Conta</th>
      <th scope="col" style="width: 450px">Valor Prest.Conta</th>
      <th *ngIf="tipo==='F'" scope="col" style="width: 250px">Empenho N˚</th>
      <th scope="col" style="width: 80px">Parcela</th>
      <th scope="col" style="width: 15%">
        <span *ngIf="tipo==='C'">Data Recebimento</span>
        <span *ngIf="tipo==='F'">Data Pagamento</span>
      </th>
      <th scope="col" style="width: 15%">
        <span *ngIf="tipo==='C'">Valor Recebido</span>
        <span *ngIf="tipo==='F'">Valor Pago</span>
      </th>
      <th scope="col" style="width: 15%">Data Contabilização</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaPrest; let idx = index">
      <td *ngIf="!item.editavel">{{item.data_prestacao | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel">{{item.valor_prestacao | number: '1.2-2'}}</td>
      <td *ngIf="tipo==='F' && !item.editavel">{{item.numero}}</td>
      <td class="text-center" *ngIf="!item.editavel">{{item.parcela}}</td>
      <td class="font-weight-bold" *ngIf="!item.editavel">{{item.data_quitacao | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td class="font-weight-bold" *ngIf="!item.editavel">{{item.valor_quitacao | number: '1.2-2'}}</td>
      <td class="font-weight-bold" *ngIf="!item.editavel">{{item.data_contabilizacao | date: 'dd/MM/yyyy':'GMT'}}</td>

      <td *ngIf="item.editavel && entity">
        <p-calendar id="data_prestacao" [(ngModel)]="entity.data_prestacao" inputStyleClass="form-control"
          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small"
          [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel && entity">
        <input [(ngModel)]="entity.valor_prestacao" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_prestacao"
          placeholder="0,00">
      </td>
      <td *ngIf="tipo==='F' && item.editavel && entity">
        <input [(ngModel)]="entity.numero" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm">
      </td>
      <td *ngIf="item.editavel && entity">
        <input [(ngModel)]="entity.parcela" [ngModelOptions]="{standalone: true}" type="text" (blur)="buscarEmpenho()"
          class="form-control form-control-sm">
      </td>
      <td *ngIf="item.editavel && entity">
        <p-calendar id="data_quitacao" [(ngModel)]="entity.data_quitacao" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>

      <td *ngIf="item.editavel && entity">
        <input [(ngModel)]="entity.valor_quitacao" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_quitacao"
          placeholder="0,00">
      </td>
      <td *ngIf="item.editavel && entity" style="width: 130px">
        <p-calendar id="data_contabil" [(ngModel)]="entity.data_contabilizacao" inputStyleClass="form-control"
          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small"
          [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td class="text-right" style="min-width: 130px;">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && funcaoService.podeAlterar(item.data_contabilizacao, login)"
          (click)="editar(item)" #btnsEditar class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="confirmarRemocao(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>


<app-convenio-prestacao-dlg [(entidade)]="entidade" [login]="login" (callback)="callbackPrestacao($event)">
</app-convenio-prestacao-dlg>